import {useMemo} from 'react';
import {useFilterOptions} from '../../tickets/hooks/useFilterOptions';
import type {FilterOptionItem} from '../../tickets/hooks/useFilterOptions';

export interface DashboardFilterOptions {
	assigneeOptions: FilterOptionItem[];
	requesterOptions: FilterOptionItem[];
	labelOptions: FilterOptionItem[];
}

export function useDashboardFilterOptions(): DashboardFilterOptions {
	const {assigneeOptions, requesterOptions, labelOptions} = useFilterOptions();

	return useMemo(
		() => ({assigneeOptions, requesterOptions, labelOptions}),
		[assigneeOptions, requesterOptions, labelOptions]
	);
}

// The Contact filter — a contact list scoped to the selected Requester — is
// deferred to v1.1: it needs the Company+Contact split in the backend schema
// (see docs/spec/ticketing/frontend/dashboard-filter-panel.md "Deferred").
